import React, { useState } from "react";
import "./rentalYieldCalculator.css";

export default function RentalYieldCalculator() {
  const [purchasePrice, setPurchasePrice] = useState("");
  const [monthlyRent, setMonthlyRent] = useState("");
  const [deductTax, setDeductTax] = useState(false);
  const [result, setResult] = useState(null);

  function calculateYield(e) {
    e.preventDefault();

    const price = parseFloat(purchasePrice) || 0;
    const rent = parseFloat(monthlyRent) || 0;

    if (price <= 0 || rent <= 0) {
      setResult({
        error:
          "Please enter a valid purchase price and monthly rent greater than zero.",
      });
      return;
    }

    let annualIncome = rent * 12;
    if (deductTax) {
      annualIncome *= 0.9;
    }

    const yieldPercent = (annualIncome / price) * 100;
    setResult({
      annualIncome,
      yieldPercent,
      error: null,
    });
  }

  return (
    <div className="rental-yield-calc-box">
      <h3>Kathmandu Rental Yield Calculator</h3>
      <form onSubmit={calculateYield}>
        <label>Property Purchase Price (NPR):</label>
        <input
          type="number"
          min="0"
          value={purchasePrice}
          onChange={(e) => setPurchasePrice(e.target.value)}
          placeholder="e.g. 20000000"
        />

        <label>Monthly Rent Expected (NPR):</label>
        <input
          type="number"
          min="0"
          value={monthlyRent}
          onChange={(e) => setMonthlyRent(e.target.value)}
          placeholder="e.g. 80000"
        />

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={deductTax}
            onChange={(e) => setDeductTax(e.target.checked)}
          />
          Deduct 10% Ward Rent Tax (Calculate Net Yield)
        </label>

        <button type="submit">Calculate Yield</button>
      </form>

      {result &&
        (result.error ? (
          <div className="yield-error">{result.error}</div>
        ) : (
          <div className="yield-result">
            <p>
              <strong>Annual Income:</strong> Rs.{" "}
              <span>{result.annualIncome.toLocaleString("en-IN")}</span>
            </p>
            <h4>
              Yield: <span>{result.yieldPercent.toFixed(2)}</span>%
            </h4>
          </div>
        ))}
    </div>
  );
}
